export default __webpack_public_path__ + "static/media/lib-transparent.8ed58ed1.svg";